import { PopupType } from '@common/types/popups';
import type { PopupMetaMap } from '@common/types/popups';

export const usePopup = () => {
  const currentPopup = useState<PopupType | null>('current-popup', () => null);
  const popupMeta = useState<PopupMetaMap[PopupType] | null>('popup-meta', () => null);

  const isOpen = computed(() => currentPopup.value !== null);

  // Типизированное открытие попапа с условным типом для меты
  const openPopup = <T extends PopupType>(
    type: T,
    ...args: PopupMetaMap[T] extends null ? [] | [null] : [PopupMetaMap[T]]
  ): void => {
    currentPopup.value = type;
    popupMeta.value = (args[0] ?? null) as PopupMetaMap[PopupType] | null;
  };

  const openDynamicPopup = (meta: PopupMetaMap[PopupType.DYNAMIC]) => {
    openPopup(PopupType.DYNAMIC, meta);
  };

  const closePopup = () => {
    currentPopup.value = null;
    popupMeta.value = null;
  };

  // Типизированный getter для меты конкретного попапа
  const getMeta = <T extends PopupType>(type: T): PopupMetaMap[T] | null => {
    if (currentPopup.value === type) {
      return popupMeta.value as PopupMetaMap[T];
    }
    return null;
  };

  return {
    currentPopup: readonly(currentPopup),
    popupMeta: readonly(popupMeta),

    isOpen,
    openPopup,
    openDynamicPopup,
    closePopup,
    getMeta,
  };
};
